var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { styled } from 'styled-components';
import { DiagramProgress } from './DiagramProgress';
import { DiagramDistribution } from './DiagramDistribution';
import { Readiness } from './Readiness';
import { useYearlyDashboardAnalytics, YearlyDashboardEvents, } from '../../hooks/useYearlyDashboardAnalytics';
import { ShadowBox } from '@hn-ui/boxes';
var VERTICAL_PADDING = 24;
var GAP = 20;
var Container = styled(ShadowBox).withConfig({ displayName: "Container", componentId: "sc-of1nmd" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 319px;\n\n  [data-id='content-box'] {\n    display: flex;\n    gap: ", "px;\n    padding: ", "px 20px;\n\n    > * {\n      position: relative;\n\n      &:not(:last-child)::after {\n        content: '';\n        position: absolute;\n        right: -", "px;\n        top: -", "px;\n        bottom: -", "px;\n        width: 2px;\n        background-color: #e3f2fc;\n      }\n    }\n  }\n"], ["\n  min-height: 319px;\n\n  [data-id='content-box'] {\n    display: flex;\n    gap: ", "px;\n    padding: ", "px 20px;\n\n    > * {\n      position: relative;\n\n      &:not(:last-child)::after {\n        content: '';\n        position: absolute;\n        right: -", "px;\n        top: -", "px;\n        bottom: -", "px;\n        width: 2px;\n        background-color: #e3f2fc;\n      }\n    }\n  }\n"])), GAP, VERTICAL_PADDING, GAP / 4, VERTICAL_PADDING, VERTICAL_PADDING);
var VerticalLine = styled.div.withConfig({ displayName: "VerticalLine", componentId: "sc-i1xpog" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  border: 1px solid #e3f2fc;\n  background-color: #e3f2fc;\n"], ["\n  height: 100%;\n  border: 1px solid #e3f2fc;\n  background-color: #e3f2fc;\n"])));
var Diagrams = function (_a) {
    var _b = _a.data, progressData = _b.progressData, distributionData = _b.distributionData, readinessData = _b.readinessData, rest = __rest(_a, ["data"]);
    var sendGaEvent = useYearlyDashboardAnalytics();
    var handleDiagramHover = useCallback(function () {
        sendGaEvent(YearlyDashboardEvents.diagramsPieChartHover);
    }, [sendGaEvent]);
    var memoizedDiagramDistribution = useMemo(function () { return (_jsx(DiagramDistribution, { data: distributionData, onDiagramHover: handleDiagramHover }, void 0)); }, [distributionData, handleDiagramHover]);
    var memoizedDiagramProgress = useMemo(function () { return (_jsx(DiagramProgress, { data: progressData, onDiagramHover: handleDiagramHover }, void 0)); }, [progressData, handleDiagramHover]);
    return (_jsxs(Container, __assign({}, rest, { borderRadius: 12 }, { children: [memoizedDiagramDistribution, memoizedDiagramProgress, _jsx(Readiness, { data: readinessData }, void 0)] }), void 0));
};
export { Diagrams };
var templateObject_1, templateObject_2;
